// Remember this only applies to the messaging components, other trix call sites
// work differently and do not have rich_content as a field.
//
// Helpers for deciding whether a Trix-composed message should be sent as plain
// `content` or rich `rich_content`.
//
// Trix always serializes text into bare block wrappers (`<div>`, `<br>`) and
// only emits semantic tags when the user actually applies formatting. Old
// mobile clients render `content` (plain text) and ignore `rich_content`, so we
// keep unformatted messages plain and only "upgrade" to rich_content when the
// user styled something. See the note atop app/models/message.rb.

// Semantic tags Trix emits when formatting is applied (bold, italic, strike,
// links, headings, quotes, code, lists). Block-level <div>/<br> are NOT here —
// plain multi-line text uses those and must stay plain.
const RICH_TAG_SELECTOR = 'strong, b, em, i, a, h1, h2, h3, ul, ol, li, blockquote, pre, del, s, u';

export function hasFormatting(html) {
  if (!html) return false;
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.querySelector(RICH_TAG_SELECTOR) !== null;
  } catch (_) {
    // If parsing fails for any reason, fall back to treating it as rich so we
    // never silently drop formatting the user applied.
    return true;
  }
}

// Builds the `message` body payload for a send/edit request. `html` is the Trix
// serialized HTML (from readRichContent); `plain` is the plain-text form
// (trixEditor.getDocument().toString()). Returns `{ rich_content }` when the
// user applied formatting, otherwise `{ content }` so old clients render it.
export function messageBody({ html, plain }) {
  if (hasFormatting(html)) {
    return { rich_content: html };
  }
  return { content: (plain || '').trim() };
}
